<template>
  <div v-show="suggested_addons.length > 0">
    <!-- use pb-terms for the subscripton term length items 1 year, 2 years etc or for Plus zones -->
    <div v-show="show_addon_configuration_step" class="pb-terms pb-grey-bck pl-30 pr-30 pt-20">
      <div class="title pull-left pull-left pb-title col-sm-8 col-xs-12 pl-0 mb-lg-30 mb-0">Addon {{ product_card_title }}</div>
      <div v-if="!!newly_added_addon && item.options.term_type === 'monthly'" class="price pull-right-md pull-left col-sm-4 col-xs-12 text-right-md pt-md-3 pt-15 pl-0 pb-20 pb-lg-0 pr-0">${{ newly_added_addon.options.prices.monthly }}</div>
      <div v-if="!!newly_added_addon && item.options.term_type === 'annually'" class="price pull-right-md pull-left col-sm-4 col-xs-12 text-right-md pt-md-3 pt-15 pl-0 pb-20 pb-lg-0 pr-0">${{ newly_added_addon.options.prices.annually }}</div>
      <div class="form-group pull-left full-width mb-5">
        <div class="col-sm-12 pl-0">
          <div class="term-container pull-left d-block mt-20">
            <select-box :active="newly_added_addon === null" :styles="{ col: 'col-sm-4 col-xs-12 term-col' }" @click.native="addAddon(null)" class="mb-20">
              <span slot="text" class="text-semibold pt-25 pb-10">None</span>
            </select-box>
            <div v-for="addon in suggested_addons" :key="`${addon.product_name}_${addon.quantity}`">
              <select-box :key="addon.id" :active="newly_added_addon && new_addon_id === `${addon.product_name}_${addon.quantity}`" :styles="{ col: 'col-sm-4 col-xs-12 term-col' }" @click.native="addAddon(addon)" class="mb-20">
                <span slot="text" class="text-semibold pt-25 pb-10">{{ addon.quantity }} {{ quant_label }} {{ item.options.term_type.charAt(0).toUpperCase() + item.options.term_type.slice(1) }}</span>
                <span v-if="item.options.term_type === 'monthly'" slot="price" class="term-title-monthly pb-30">{{ addon.price_monthly }}</span>
                <span v-if="item.options.term_type === 'annually'" slot="price" class="term-title-monthly pb-30">{{ addon.price_yearly }}</span>
              </select-box>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SelectBox from './SelectBox.vue';

export default {
  name: 'AddonConfiguration',
  components: { SelectBox },

  props: {
    item: {
      type: Object,
      required: true,
      validator: function (value) {
        return value !== null && typeof value === 'object' && typeof value.title === 'string' && value.title.trim() !== '';
      }
    },
    addon_name: {
      type: String,
      required: true
    },
    suggested_addons: {
      type: Array,
      required: true,
      default: () => [],
      validator: function (value) {
        return value.every(item => item !== null && typeof item === 'object' && typeof item.quantity === 'number' && typeof item.product_name === 'string' && typeof item.title === 'string' && typeof item.price_monthly === 'string' && typeof item.price_yearly === 'string');
      }
    }
  },

  data() {
    return {
      newly_added_addon: null,
      show_addon_configuration_step: true
    };
  },

  created() {
    this.newly_added_addon = Array.isArray(this.addon_items) ? this.addon_items.find(item => item.parent_id === this.item.id) || null : null;
  },

  computed: {
    ...mapState({
      addon_items: state => state.cart.addon_items
    }),
    product_card_title: function () {
      if (this.addon_name === 'team.login') {
        return 'Team Login';
      }

      return '';
    },
    quant_label: function () {
      if (this.addon_name === 'team.login') {
        return 'Seat(s)';
      }

      return '';
    },
    new_addon_id: function () {
      if (!this.newly_added_addon) {
        return null;
      }

      return `${this.newly_added_addon.product_id}_${this.newly_added_addon.options.quantity}`;
    }
  },

  methods: {
    addAddon(selected_addon) {
      if (!selected_addon) {
        this.removeAddon();
        this.newly_added_addon = null;
        return;
      }

      // Don't allow double click
      if (this.newly_added_addon && `${selected_addon.product_name}_${selected_addon.quantity}` === this.new_addon_id) {
        return;
      }

      if (this.newly_added_addon) {
        this.removeAddOnItem({ id: this.newly_added_addon.id });
      }

      let product_data = {
        product_id: selected_addon.product_name,
        term: this.item.term,
        options: {
          term_type: this.item.options.term_type,
          parent_id: this.item.id,
          quantity: selected_addon.quantity
        }
      };

      this.$emit('update:loading', true);

      this.addCartItem(product_data)
        .then(() => {
          this.newly_added_addon = this.addon_items.find(item => item.parent_id === this.item.id) || null;
          this.$emit('update:loading', false);
        })
        .catch(() => {
          this.newly_added_addon = null;
          this.$emit('update:loading', false);
        });
    },

    removeAddon() {
      if (!this.newly_added_addon) {
        return;
      }

      this.$emit('update:loading', true);

      this.removeAddOnItem({ id: this.newly_added_addon.id })
        .then(() => {
          this.newly_added_addon = null;
          this.$emit('update:loading', false);
        })
        .catch(() => {
          this.$emit('update:loading', false);
        });
    },

    ...mapActions('cart', ['removeAddOnItem', 'addCartItem'])
  }
};
</script>
